import i18n from '@/plugins/i18n'

export enum MembershipPlanInterval {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  HALF_YEARLY = 'half_yearly',
  YEARLY = 'yearly'
}

export const MembershipPlanIntervals = {
  [MembershipPlanInterval.MONTHLY]: {
    get text() { return i18n.t('membership_plan.monthly') },
    get pricePer() { return i18n.t('membership_plan.month') }
  },
  [MembershipPlanInterval.QUARTERLY]: {
    get text() { return i18n.t('membership_plan.quarterly') },
    get pricePer() { return i18n.t('membership_plan.quarter') }
  },
  [MembershipPlanInterval.HALF_YEARLY]: {
    get text() { return i18n.t('membership_plan.half_yearly') },
    get pricePer() { return i18n.t('membership_plan.half_a_year') }
  },
  [MembershipPlanInterval.YEARLY]: {
    get text() { return i18n.t('membership_plan.yearly') },
    get pricePer() { return i18n.t('membership_plan.year') }
  }
}

export interface IMembershipPlan {
  id: number;
  title: string;
  price: number;
  currency: string;
  interval: string;
}

export interface IMembershipPeriod {
  id: number;
  interval: string;
  date: string;
}
